import { Ticket } from './models/ticket.model';

export const MOCK_TICKETS: Ticket[] = [
	// {
	// 	id: 'TCK-021',
	// 	userId: 'USR-104',
	// 	subject: 'Stampante posseduta da spiriti maligni',
	// 	description: 'La stampante stampa solo pagine bianche tranne quando non deve.',
	// 	status: 'TO_DO',
	// 	category: 'NOT_CATEGORIZED',
	// 	priority: 'MEDIUM',
	// 	createdAt: new Date('2025-03-01T09:12:00'),
	// 	assignee_user_id: '',
	// 	tags: [],
	// 	events: [],
	// 	notes: []
	// },
	// {
	// 	id: 'TCK-022',
	// 	userId: 'USR-107',
	// 	subject: 'Accesso VPN lunatico',
	// 	description: 'La VPN funziona solo dopo aver riavviato il PC tre volte.',
	// 	status: 'TO_DO',
	// 	category: 'NOT_CATEGORIZED',
	// 	priority: 'HIGH',
	// 	createdAt: new Date('2025-03-02T11:45:00'),
	// 	assignee_user_id: '',
	// 	tags: [],
	// 	events: [],
	// 	notes: []
	// },
	// {
	// 	id: 'TCK-023',
	// 	userId: 'USR-110',
	// 	subject: 'Email sparite nel nulla',
	// 	description: 'Le email inviate ieri non risultano né inviate né ricevute.',
	// 	status: 'TO_DO',
	// 	category: 'NOT_CATEGORIZED',
	// 	priority: 'HIGH',
	// 	createdAt: new Date('2025-03-03T08:30:00'),
	// 	assignee_user_id: '',
	// 	tags: [],
	// 	events: [],
	// 	notes: []
	// },
	// {
	// 	id: 'TCK-024',
	// 	userId: 'USR-115',
	// 	subject: 'Mouse che decide da solo',
	// 	description: 'Il cursore si muove autonomamente verso angoli casuali.',
	// 	status: 'TO_DO',
	// 	category: 'NOT_CATEGORIZED',
	// 	priority: 'LOW',
	// 	createdAt: new Date('2025-03-03T15:10:00'),
	// 	assignee_user_id: '',
	// 	tags: [],
	// 	events: [],
	// 	notes: []
	// },
	// {
	// 	id: 'TCK-025',
	// 	userId: 'USR-118',
	// 	subject: 'Password improvvisamente errata',
	// 	description: 'Password corretta ieri, oggi rifiutata senza motivo apparente.',
	// 	status: 'TO_DO',
	// 	category: 'NOT_CATEGORIZED',
	// 	priority: 'URGENT',
	// 	createdAt: new Date('2025-03-04T10:05:00'),
	// 	assignee_user_id: '',
	// 	tags: [],
	// 	events: [],
	// 	notes: []
	// },
	// {
	// 	id: 'TCK-026',
	// 	userId: 'USR-120',
	// 	subject: 'Monitor nero ma acceso',
	// 	description: 'Il monitor è acceso ma mostra solo il vuoto cosmico.',
	// 	status: 'TO_DO',
	// 	category: 'NOT_CATEGORIZED',
	// 	priority: 'HIGH',
	// 	createdAt: new Date('2025-03-04T14:42:00'),
	// 	assignee_user_id: '',
	// 	tags: [],
	// 	events: [],
	// 	notes: []
	// },
	// {
	// 	id: 'TCK-027',
	// 	userId: 'USR-123',
	// 	subject: 'Applicazione bloccata in caricamento',
	// 	description: 'La schermata di loading gira da oltre 20 minuti.',
	// 	status: 'IN_PROGRESS',
	// 	category: 'SUPPORT',
	// 	priority: 'URGENT',
	// 	createdAt: new Date('2025-03-05T09:00:00'),
	// 	assignee_user_id: 'u007',
	//
	// 	tags: [
	// 		{
	// 			id: '1',
	// 			label: 'Bello',
	// 			color: 'blue-400',
	// 			active: true
	// 		},
	// 		{
	// 			id: '2',
	// 			label: 'MMMMM',
	// 			color: 'orange-400',
	// 			active: true
	// 		},
	// 		{
	// 			id: '3',
	// 			label: 'Capperi',
	// 			color: 'red-400',
	// 			active: true
	// 		}
	// 	],
	//
	// 	notes: [
	// 		{
	// 			id: 'C-005',
	// 			userId: 'u007',
	// 			createdAt: new Date('2025-03-05T09:30:00'),
	// 			message: 'Stiamo analizzando i log applicativi.'
	// 		}
	// 	],
	//
	// 	events: [
	// 		// 🎫 Creazione ticket (implicita)
	// 		{
	// 			id: 'EVT-001',
	// 			event_type: 'NOTE_INTERNAL',
	// 			created_at: new Date('2025-03-05T09:01:00'),
	// 			created_by: 'system',
	// 			note: 'Ticket creato automaticamente da email in ingresso.'
	// 		},
	//
	// 		// 🏷 Tag aggiunti
	// 		{
	// 			id: 'EVT-002',
	// 			event_type: 'TAG_ADDED',
	// 			created_at: new Date('2025-03-05T09:05:00'),
	// 			created_by: 'u001',
	// 			tag_id: '1'
	// 		},
	// 		{
	// 			id: 'EVT-003',
	// 			event_type: 'TAG_ADDED',
	// 			created_at: new Date('2025-03-05T09:06:00'),
	// 			created_by: 'u001',
	// 			tag_id: '2'
	// 		},
	//
	// 		// 📂 Cambio categoria
	// 		{
	// 			id: 'EVT-004',
	// 			event_type: 'CATEGORY_CHANGED',
	// 			created_at: new Date('2025-03-05T09:10:00'),
	// 			created_by: 'u001',
	// 			old_category: 'NOT_CATEGORIZED',
	// 			new_category: 'SUPPORT'
	// 		},
	//
	// 		// 🚦 Cambio stato
	// 		{
	// 			id: 'EVT-005',
	// 			event_type: 'STATUS_CHANGED',
	// 			created_at: new Date('2025-03-05T09:12:00'),
	// 			created_by: 'u001',
	// 			old_status: 'TO_DO',
	// 			new_status: 'ASSIGNED'
	// 		},
	//
	// 		// 👤 Richiesta cambio assegnatario
	// 		{
	// 			id: 'EVT-006',
	// 			event_type: 'ASSIGNMENT_CHANGE_REQUESTED',
	// 			created_at: new Date('2025-03-05T09:15:00'),
	// 			created_by: 'u001',
	// 			requested_assignee_user_id: 'u007',
	// 			reason: 'Competenza specifica su problemi di autenticazione',
	// 			status: 'PENDING'
	// 		},
	//
	// 		// ✅ Approvazione cambio assegnatario
	// 		{
	// 			id: 'EVT-007',
	// 			event_type: 'ASSIGNMENT_CHANGE_APPROVED',
	// 			created_at: new Date('2025-03-05T09:18:00'),
	// 			created_by: 'u002',
	// 			request_event_id: 'EVT-006',
	// 			old_assignee_user_id: 'u001',
	// 			new_assignee_user_id: 'u007'
	// 		},
	//
	// 		// 🔺 Cambio priorità
	// 		{
	// 			id: 'EVT-008',
	// 			event_type: 'PRIORITY_CHANGED',
	// 			created_at: new Date('2025-03-05T09:20:00'),
	// 			created_by: 'u007',
	// 			old_priority: 'HIGH',
	// 			new_priority: 'URGENT'
	// 		},
	//
	// 		// 📝 Nota interna tecnica
	// 		{
	// 			id: 'EVT-009',
	// 			event_type: 'NOTE_INTERNAL',
	// 			created_at: new Date('2025-03-05T09:35:00'),
	// 			created_by: 'u007',
	// 			note: 'Possibile deadlock durante il bootstrap del modulo auth.'
	// 		},
	//
	// 		// ▶️ Stato in lavorazione
	// 		{
	// 			id: 'EVT-010',
	// 			event_type: 'STATUS_CHANGED',
	// 			created_at: new Date('2025-03-05T09:40:00'),
	// 			created_by: 'u007',
	// 			old_status: 'ASSIGNED',
	// 			new_status: 'IN_PROGRESS'
	// 		},
	//
	// 		// ❌ Rimozione tag
	// 		{
	// 			id: 'EVT-011',
	// 			event_type: 'TAG_REMOVED',
	// 			created_at: new Date('2025-03-05T10:10:00'),
	// 			created_by: 'u007',
	// 			tag_id: '2'
	// 		},
	//
	// 		// 🔁 Richiesta cambio assegnatario (rifiutata)
	// 		{
	// 			id: 'EVT-012',
	// 			event_type: 'ASSIGNMENT_CHANGE_REQUESTED',
	// 			created_at: new Date('2025-03-05T10:30:00'),
	// 			created_by: 'u003',
	// 			requested_assignee_user_id: 'u009',
	// 			reason: 'Riassegnazione carico di lavoro',
	// 			status: 'REJECTED'
	// 		},
	//
	// 		{
	// 			id: 'EVT-013',
	// 			event_type: 'ASSIGNMENT_CHANGE_REJECTED',
	// 			created_at: new Date('2025-03-05T10:45:00'),
	// 			created_by: 'u002',
	// 			request_event_id: 'EVT-012',
	// 			rejection_reason: 'Il ticket è già in fase avanzata di lavorazione'
	// 		}
	// 	]
	// },
	// {
	// 	id: 'TCK-028',
	// 	userId: 'USR-126',
	// 	subject: 'Audio robotico durante le call',
	// 	description: 'Durante le riunioni la voce diventa metallica.',
	// 	status: 'TO_DO',
	// 	category: 'NOT_CATEGORIZED',
	// 	priority: 'MEDIUM',
	// 	createdAt: new Date('2025-03-05T16:25:00'),
	// 	assignee_user_id: '',
	// 	tags: [],
	// 	events: [],
	// 	notes: []
	// },
	// {
	// 	id: 'TCK-029',
	// 	userId: 'USR-130',
	// 	subject: 'File scomparsi dal desktop',
	// 	description: 'I file erano lì ieri, oggi sono svaniti.',
	// 	status: 'TO_DO',
	// 	category: 'NOT_CATEGORIZED',
	// 	priority: 'HIGH',
	// 	createdAt: new Date('2025-03-06T08:55:00'),
	// 	assignee_user_id: '',
	// 	tags: [],
	// 	events: [],
	// 	notes: []
	// },
	// {
	// 	id: 'TCK-030',
	// 	userId: 'USR-133',
	// 	subject: 'Sistema lentissimo dopo aggiornamento',
	// 	description: 'Dopo l’ultimo update il PC impiega 10 minuti ad avviarsi.',
	// 	status: 'IN_PROGRESS',
	// 	category: 'SUPPORT',
	// 	priority: 'URGENT',
	// 	createdAt: new Date('2025-03-06T13:40:00'),
	// 	assignee_user_id: 'u010',
	// 	tags: [],
	// 	events: [],
	// 	notes: [
	// 		{
	// 			id: 'C-006',
	// 			userId: 'u010',
	// 			createdAt: new Date('2025-03-06T14:10:00'),
	// 			message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam efficitur est ut risus viverra lacinia. Donec vel augue eget magna suscipit suscipit vitae quis quam. Nulla pulvinar et ipsum quis posuere. Curabitur semper tincidunt laoreet. Sed auctor posuere ultricies. Morbi auctor sagittis sapien, at elementum enim vestibulum non. Proin eget massa nec elit sodales dapibus. Aenean pulvinar lacinia leo a egestas.'
	// 		}
	// 	]
	// },
	// {
	// 	id: 'T-001',
	// 	userId: 'U-01',
	// 	subject: 'PC non si accende',
	// 	description: 'Il computer non dà segni di vita dopo l’ultimo aggiornamento.',
	// 	status: 'TO_DO',
	// 	category: 'SUPPORT',
	// 	priority: 'URGENT',
	// 	createdAt: new Date('2025-01-02'),
	// 	assignee_user_id: '',
	// 	tags: [],
	// 	events: [],
	// 	notes: []
	// },
	// {
	// 	id: 'T-002',
	// 	userId: 'U-02',
	// 	subject: 'Password dimenticata',
	// 	description: 'Impossibile accedere al portale interno.',
	// 	status: 'ASSIGNED',
	// 	category: 'SUPPORT',
	// 	priority: 'HIGH',
	// 	createdAt: new Date('2025-01-03'),
	// 	assignee_user_id: 'u034',
	// 	tags: [],
	// 	events: [],
	// 	notes: [
	// 		{
	// 			id: 'C-008',
	// 			userId: 'u034',
	// 			createdAt: new Date('2025-01-03T10:00:00'),
	// 			message: 'Ho avviato la procedura di reset password.'
	// 		}
	// 	]
	// },
	// {
	// 	id: 'T-003',
	// 	userId: 'U-03',
	// 	subject: 'Stampante indemoniata',
	// 	description: 'Stampa solo pagine bianche e fa rumori strani.',
	// 	status: 'IN_PROGRESS',
	// 	category: 'SUPPORT',
	// 	priority: 'MEDIUM',
	// 	createdAt: new Date('2025-01-03'),
	// 	assignee_user_id: 'u003',
	// 	tags: [],
	// 	events: [],
	// 	notes: [
	// 		{
	// 			id: 'C-009',
	// 			userId: 'u003',
	// 			createdAt: new Date('2025-01-03T11:15:00'),
	// 			message: 'Driver reinstallato, in attesa di test.'
	// 		}
	// 	]
	// },
	// {
	// 	id: 'T-004',
	// 	userId: 'U-04',
	// 	subject: 'Richiesta nuovo mouse',
	// 	description: 'Il mouse attuale si muove da solo.',
	// 	status: 'PENDING',
	// 	category: 'OTHER',
	// 	priority: 'VERY_LOW',
	// 	createdAt: new Date('2025-01-04'),
	// 	assignee_user_id: 'u034',
	// 	tags: [],
	// 	events: [],
	// 	notes: []
	// },
	// {
	// 	id: 'T-005',
	// 	userId: 'U-05',
	// 	subject: 'Email lente',
	// 	description: 'Outlook impiega minuti ad aprirsi.',
	// 	status: 'CLOSED',
	// 	category: 'SUPPORT',
	// 	priority: 'MEDIUM',
	// 	createdAt: new Date('2025-01-05'),
	// 	assignee_user_id: 'u034',
	// 	tags: [],
	// 	events: [],
	// 	notes: [
	// 		{
	// 			id: 'C-010',
	// 			userId: 'u034',
	// 			createdAt: new Date('2025-01-05T15:30:00'),
	// 			message: 'Problema risolto con ricostruzione del profilo.'
	// 		}
	// 	]
	// },
	// {
	// 	id: 'T-006',
	// 	userId: 'U-06',
	// 	subject: 'Monitor tremolante',
	// 	description: 'Lo schermo sembra gelatina.',
	// 	status: 'TO_DO',
	// 	category: 'SUPPORT',
	// 	priority: 'MEDIUM',
	// 	createdAt: new Date('2025-01-06'),
	// 	assignee_user_id: '',
	// 	tags: [],
	// 	events: [],
	// 	notes: []
	// },
	// {
	// 	id: 'T-007',
	// 	userId: 'U-07',
	// 	subject: 'VPN non si connette',
	// 	description: 'Errore di autenticazione casuale.',
	// 	status: 'ASSIGNED',
	// 	category: 'SUPPORT',
	// 	priority: 'HIGH',
	// 	createdAt: new Date('2025-01-06'),
	// 	assignee_user_id: 'u006',
	// 	tags: [],
	// 	events: [],
	// 	notes: [
	// 		{
	// 			id: 'C-011',
	// 			userId: 'u006',
	// 			createdAt: new Date('2025-01-06T14:00:00'),
	// 			message: 'Credenziali aggiornate, verifica accesso.'
	// 		}
	// 	]
	// },
	// {
	// 	id: 'T-008',
	// 	userId: 'U-08',
	// 	subject: 'Software gestionale lento',
	// 	description: 'Caricamenti infiniti dopo login.',
	// 	status: 'IN_PROGRESS',
	// 	category: 'OTHER',
	// 	priority: 'HIGH',
	// 	createdAt: new Date('2025-01-07'),
	// 	assignee_user_id: 'u034',
	// 	tags: [],
	// 	events: [],
	// 	notes: []
	// },
	// {
	// 	id: 'T-009',
	// 	userId: 'U-09',
	// 	subject: 'Richiesta accesso cartella',
	// 	description: 'Permessi mancanti su drive condiviso.',
	// 	status: 'PENDING',
	// 	category: 'SUPPORT',
	// 	priority: 'MEDIUM',
	// 	createdAt: new Date('2025-01-08'),
	// 	assignee_user_id: 'u007',
	// 	tags: [],
	// 	events: [],
	// 	notes: []
	// },
	// {
	// 	id: 'T-010',
	// 	userId: 'U-10',
	// 	subject: 'PC molto lento',
	// 	description: 'Probabile presenza di software indesiderato.',
	// 	status: 'CLOSED',
	// 	category: 'SUPPORT',
	// 	priority: 'HIGH',
	// 	createdAt: new Date('2025-01-08'),
	// 	assignee_user_id: 'u009',
	// 	tags: [],
	// 	events: [],
	// 	notes: [
	// 		{
	// 			id: 'C-012',
	// 			userId: 'u009',
	// 			createdAt: new Date('2025-01-08T16:00:00'),
	// 			message: 'Pulizia completata, prestazioni ripristinate.'
	// 		}
	// 	]
	// },
	// {
	// 	id: 'T-011',
	// 	userId: 'U-11',
	// 	subject: 'Aggiornamento browser',
	// 	description: 'Richiesta aggiornamento Chrome.',
	// 	status: 'TO_DO',
	// 	category: 'OTHER',
	// 	priority: 'LOW',
	// 	createdAt: new Date('2025-01-09'),
	// 	assignee_user_id: '',
	// 	tags: [],
	// 	events: [],
	// 	notes: []
	// },
	// {
	// 	id: 'T-012',
	// 	userId: 'U-12',
	// 	subject: 'Wi-Fi instabile',
	// 	description: 'Connessione cade ogni 10 minuti.',
	// 	status: 'ASSIGNED',
	// 	category: 'SUPPORT',
	// 	priority: 'HIGH',
	// 	createdAt: new Date('2025-01-09'),
	// 	assignee_user_id: 'u002',
	// 	tags: [],
	// 	events: [],
	// 	notes: [
	// 		{
	// 			id: 'C-013',
	// 			userId: 'u002',
	// 			createdAt: new Date('2025-01-09T11:20:00'),
	// 			message: 'Puoi indicarmi se il problema avviene su tutte le reti o solo in ufficio?'
	// 		},
	// 		{
	// 			id: 'C-024',
	// 			userId: 'u002',
	// 			createdAt: new Date('2025-01-09T11:45:00'),
	// 			message: 'Stiamo monitorando la stabilità della rete sul tuo piano.'
	// 		},
	// 		{
	// 			id: 'C-025',
	// 			userId: 'u002',
	// 			createdAt: new Date('2025-01-09T12:30:00'),
	// 			message: 'Abbiamo rilevato interferenze sul canale Wi-Fi.'
	// 		},
	// 		{
	// 			id: 'C-026',
	// 			userId: 'u002',
	// 			createdAt: new Date('2025-01-09T13:10:00'),
	// 			message: 'Canale aggiornato. Puoi confermare se la connessione è stabile ora?'
	// 		}
	// 	]
	// },
	// {
	// 	id: 'T-013',
	// 	userId: 'U-13',
	// 	subject: 'Microfono non funziona',
	// 	description: 'Problemi durante le call.',
	// 	status: 'IN_PROGRESS',
	// 	category: 'SUPPORT',
	// 	priority: 'HIGH',
	// 	createdAt: new Date('2025-01-10'),
	// 	assignee_user_id: 'u010',
	// 	tags: [],
	// 	events: [],
	// 	notes: [
	// 		{
	// 			id: 'C-014',
	// 			userId: 'u010',
	// 			createdAt: new Date('2025-01-10T09:45:00'),
	// 			message: 'Il microfono risulta disabilitato nelle impostazioni di sistema.'
	// 		},
	// 		{
	// 			id: 'C-027',
	// 			userId: 'u010',
	// 			createdAt: new Date('2025-01-10T10:10:00'),
	// 			message: 'Ho riattivato il dispositivo audio predefinito.'
	// 		},
	// 		{
	// 			id: 'C-028',
	// 			userId: 'u010',
	// 			createdAt: new Date('2025-01-10T10:30:00'),
	// 			message: 'Fammi sapere se ora riesci a parlare correttamente in call.'
	// 		}
	// 	]
	// },
	// {
	// 	id: 'T-014',
	// 	userId: 'U-14',
	// 	subject: 'Errore applicazione HR',
	// 	description: 'Crash all’apertura.',
	// 	status: 'PENDING',
	// 	category: 'OTHER',
	// 	priority: 'MEDIUM',
	// 	createdAt: new Date('2025-01-11'),
	// 	assignee_user_id: 'u004',
	// 	tags: [],
	// 	events: [],
	// 	notes: [
	// 		{
	// 			id: 'C-015',
	// 			userId: 'u004',
	// 			createdAt: new Date('2025-01-11T10:30:00'),
	// 			message: 'Problema noto, in attesa di patch dal fornitore.'
	// 		}
	// 	]
	// },
	// {
	// 	id: 'T-015',
	// 	userId: 'U-15',
	// 	subject: 'Richiesta nuovo account',
	// 	description: 'Nuovo dipendente da configurare.',
	// 	status: 'CLOSED',
	// 	category: 'SUPPORT',
	// 	priority: 'LOW',
	// 	createdAt: new Date('2025-01-11'),
	// 	assignee_user_id: 'u001',
	// 	tags: [],
	// 	events: [],
	// 	notes: [
	// 		{
	// 			id: 'C-016',
	// 			userId: 'u001',
	// 			createdAt: new Date('2025-01-11T15:00:00'),
	// 			message: 'Account creato e credenziali inviate.'
	// 		}
	// 	]
	// },
	// {
	// 	id: 'T-016',
	// 	userId: 'U-16',
	// 	subject: 'Mouse invertito',
	// 	description: 'Click destro e sinistro scambiati.',
	// 	status: 'TO_DO',
	// 	category: 'OTHER',
	// 	priority: 'VERY_LOW',
	// 	createdAt: new Date('2025-01-12'),
	// 	assignee_user_id: '',
	// 	tags: [],
	// 	events: [],
	// 	notes: []
	// },
	// {
	// 	id: 'T-017',
	// 	userId: 'U-17',
	// 	subject: 'Schermo blu',
	// 	description: 'BSOD casuale durante il lavoro.',
	// 	status: 'ASSIGNED',
	// 	category: 'SUPPORT',
	// 	priority: 'URGENT',
	// 	createdAt: new Date('2025-01-12'),
	// 	assignee_user_id: 'u007',
	// 	tags: [],
	// 	events: [],
	// 	notes: [
	// 		{
	// 			id: 'C-017',
	// 			userId: 'u007',
	// 			createdAt: new Date('2025-01-12T14:10:00'),
	// 			message: 'Puoi inviarmi una foto del codice di errore del BSOD?'
	// 		},
	// 		{
	// 			id: 'C-029',
	// 			userId: 'u007',
	// 			createdAt: new Date('2025-01-12T15:00:00'),
	// 			message: 'Analisi del dump di memoria in corso.'
	// 		},
	// 		{
	// 			id: 'C-030',
	// 			userId: 'u007',
	// 			createdAt: new Date('2025-01-12T16:20:00'),
	// 			message: 'Il problema sembra legato al driver video.'
	// 		},
	// 		{
	// 			id: 'C-031',
	// 			userId: 'u007',
	// 			createdAt: new Date('2025-01-12T17:00:00'),
	// 			message: 'Driver aggiornato. Monitoriamo eventuali nuovi crash.'
	// 		}
	// 	]
	// },
	// {
	// 	id: 'T-018',
	// 	userId: 'U-18',
	// 	subject: 'Account bloccato',
	// 	description: 'Troppi tentativi di login.',
	// 	status: 'IN_PROGRESS',
	// 	category: 'SUPPORT',
	// 	priority: 'URGENT',
	// 	createdAt: new Date('2025-01-13'),
	// 	assignee_user_id: 'u006',
	// 	tags: [],
	// 	events: [],
	// 	notes: [
	// 		{
	// 			id: 'C-018',
	// 			userId: 'u006',
	// 			createdAt: new Date('2025-01-13T09:00:00'),
	// 			message: 'Account bloccato per tentativi errati consecutivi.'
	// 		},
	// 		{
	// 			id: 'C-032',
	// 			userId: 'u006',
	// 			createdAt: new Date('2025-01-13T09:15:00'),
	// 			message: 'Ho sbloccato l’account e forzato il reset password.'
	// 		},
	// 		{
	// 			id: 'C-033',
	// 			userId: 'u006',
	// 			createdAt: new Date('2025-01-13T09:40:00'),
	// 			message: 'Puoi confermare se riesci ad accedere ora?'
	// 		}
	// 	]
	// },
	// {
	// 	id: 'T-019',
	// 	userId: 'U-19',
	// 	subject: 'Richiesta cuffie',
	// 	description: 'Necessarie per smart working.',
	// 	status: 'PENDING',
	// 	category: 'OTHER',
	// 	priority: 'MEDIUM',
	// 	createdAt: new Date('2025-01-13'),
	// 	assignee_user_id: 'u008',
	// 	tags: [],
	// 	events: [],
	// 	notes: []
	// },
	// {
	// 	id: 'T-020',
	// 	userId: 'U-20',
	// 	subject: 'Problema backup',
	// 	description: 'Backup notturno fallito.',
	// 	status: 'CLOSED',
	// 	category: 'SUPPORT',
	// 	priority: 'HIGH',
	// 	createdAt: new Date('2025-01-14'),
	// 	assignee_user_id: 'u005',
	// 	tags: [],
	// 	events: [],
	// 	notes: [
	// 		{
	// 			id: 'C-019',
	// 			userId: 'u005',
	// 			createdAt: new Date('2025-01-14T08:30:00'),
	// 			message: 'Backup ripristinato e verificato.'
	// 		}
	// 	]
	// },
	// {
	// 	id: 'T-021',
	// 	userId: 'U-21',
	// 	subject: 'Laptop surriscaldato',
	// 	description: 'Ventola sempre al massimo.',
	// 	status: 'TO_DO',
	// 	category: 'SUPPORT',
	// 	priority: 'MEDIUM',
	// 	createdAt: new Date('2025-01-14'),
	// 	assignee_user_id: '',
	// 	tags: [],
	// 	events: [],
	// 	notes: []
	// },
	// {
	// 	id: 'T-022',
	// 	userId: 'U-22',
	// 	subject: 'Errore login SAP',
	// 	description: 'Credenziali rifiutate.',
	// 	status: 'ASSIGNED',
	// 	category: 'SUPPORT',
	// 	priority: 'HIGH',
	// 	createdAt: new Date('2025-01-15'),
	// 	assignee_user_id: 'u002',
	// 	tags: [],
	// 	events: [],
	// 	notes: [
	// 		{
	// 			id: 'C-020',
	// 			userId: 'u002',
	// 			createdAt: new Date('2025-01-15T10:00:00'),
	// 			message: 'Permessi riallineati, riprova il login.'
	// 		}
	// 	]
	// },
	// {
	// 	id: 'T-023',
	// 	userId: 'U-23',
	// 	subject: 'Richiesta monitor extra',
	// 	description: 'Necessario per produttività.',
	// 	status: 'IN_PROGRESS',
	// 	category: 'SUPPORT',
	// 	priority: 'MEDIUM',
	// 	createdAt: new Date('2025-01-15'),
	// 	assignee_user_id: 'u034',
	// 	tags: [],
	// 	events: [],
	// 	notes: [
	// 		{
	// 			id: 'C-021',
	// 			userId: 'u034',
	// 			createdAt: new Date('2025-01-15T16:40:00'),
	// 			message: 'Puoi indicare il modello<br> richiesto o le dimensioni preferite?'
	// 		},
	// 		{
	// 			id: 'C-034',
	// 			userId: 'u009',
	// 			createdAt: new Date('2025-01-15T17:10:00'),
	// 			message: 'Richiesta approvata dal responsabile.'
	// 		},
	// 		{
	// 			id: 'C-035',
	// 			userId: 'u034',
	// 			createdAt: new Date('2025-01-16T09:00:00'),
	// 			message: 'Ordine effettuato, in attesa di consegna.'
	// 		},
	// 		{
	// 			id: 'C-036',
	// 			userId: 'u009',
	// 			createdAt: new Date('2025-01-16T14:30:00'),
	// 			message: 'Ti aggiorniamo appena il monitor arriva.'
	// 		}
	// 	]
	// },
	// {
	// 	id: 'T-024',
	// 	userId: 'U-24',
	// 	subject: 'Errore antivirus',
	// 	description: 'Segnalazioni false positive.',
	// 	status: 'PENDING',
	// 	category: 'SUPPORT',
	// 	priority: 'MEDIUM',
	// 	createdAt: new Date('2025-01-16'),
	// 	assignee_user_id: 'u003',
	// 	tags: [],
	// 	events: [],
	// 	notes: [
	// 		{
	// 			id: 'C-022',
	// 			userId: 'u003',
	// 			createdAt: new Date('2025-01-16T09:50:00'),
	// 			message: 'Stiamo aggiornando le definizioni antivirus.'
	// 		}
	// 	]
	// },
	// {
	// 	id: 'T-025',
	// 	userId: 'U-25',
	// 	subject: 'Accesso CRM',
	// 	description: 'Permessi mancanti.',
	// 	status: 'CLOSED',
	// 	category: 'SUPPORT',
	// 	priority: 'LOW',
	// 	createdAt: new Date('2025-01-16'),
	// 	assignee_user_id: 'u002',
	// 	tags: [],
	// 	events: [],
	// 	notes: [
	// 		{
	// 			id: 'C-023',
	// 			userId: 'u002',
	// 			createdAt: new Date('2025-01-16T14:20:00'),
	// 			message: 'Permessi assegnati correttamente.'
	// 		}
	// 	]
	// }
]
